export default "__VITE_ASSET__Ch_U5WWD__"